<template>
  <div class="notice">
    <ul>
      <li v-for="(item,a) in Data" :key="a">
        <a href @click="toDetail($event,item,item.Id)"><img src="../../../assets/images/arrow.gif" />{{item.Title}}</a>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Data: []
    };
  },
  props: ["params"],
  mounted() {
    this.$store
      .dispatch("_getActor", this.params)
      .then(res => {
        this.Data = res.data.Data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods:{
    toDetail(e, x, id) {
      e.preventDefault();
      if (x.DataType == "Text" || x.DataType == "文字") {
        let routeUrl = this.$router.resolve({
          path: "/NewsDetails?ItemId=" + id
        });
        window.open(routeUrl.href, "_blank");
      } else if (x.DataType == "File" || x.DataType == "文件") {
        if (x.FileGUID == "") {
          alert("下载失败,未发现文件");
          return;
        }
        var aa = x.FileGUID;
        var ac = x.Title;
        this.OpenGUIDFile(aa);
      } else if (x.DataType == "Link" || x.DataType == "链接") {
        window.open(x.Url, "_blank");
      }
    },
    OpenGUIDFile(FileGUID) {
      this.$store
        .dispatch("_OpenGUIDFile", { FileGUID: FileGUID })
        .then(res => {
          if (res.data.IsSuccess) {
            this.$Download.DownloadBase64File(
              res.data.Data.File,
              res.data.Data.FileName
            );
          } else {
            alert(res.data.Message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>